module.exports = __webpack_public_path__ + "media/volvo/assets/images/volvo_xc70@2x-8ae077d36dec5eb145fffa743da1eabc.png";